import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function MasterPrivilegios({ user , permissions, setPermissions }) {
  return (
    <>
      <Header header={'Privilégios Master'} />

      <InfoFieldGroup
        fields={
          [
            {
              // label: 'Conceder todos Privilégios',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'allPermissions'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Conceder todos Privilégios do sistema'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: 'Conceder todos Privilégios',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'concederPermissions'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Conceder Privilégios'}
                  descricao={''}
                />
              , editable: false,
            },
          ]
        } />

    </>
  )
}
